export default [
  {
    path: '/admin/defines/sectors',
    name: 'Sectors',
    component: () => import('@/views/Admin/Defines/Sectors/Index.vue'),
    meta: {
      pageTitle: 'Sektörler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/sectors/add',
    name: 'SectorAdd',
    component: () => import('@/views/Admin/Defines/Sectors/Add.vue'),
    meta: {
      pageTitle: 'Sektörler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/sectors',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/sectors/edit/:id',
    name: 'SectorEdit',
    component: () => import('@/views/Admin/Defines/Sectors/Edit.vue'),
    meta: {
      pageTitle: 'Sektörler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/sectors',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
